import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(LanguageEn);

    /** @ngInject */
    function LanguageEn($translateProvider) {
        $translateProvider.translations('en',
            // TRANSLATIONS
{
    "common": {
        "add": "Add",
        "attachment": "Attachment",
        "attachments": "Attachments",
        "change": "Change",
        "cancel": "Cancel",
        "close": "Close",
        "closed": "Closed",
        "delete": "Delete",
        "edit": "Edit",
        "element_exists": "Element exists",
        "filename": "Filename",
        "hide": "Hide",
        "id": "ID",
        "no_results": "No results",
        "optional": "Optional",
        "status": "Status",
        "save": "Save",
        "saved": "Saved",
        "select": "Select",
        "select_all": "Select all",
        "send": "Send",
        "sent": "Sent",
        "changes_saved": "Changes saved",
        "deleting": "Deleting",
        "optionally": "Optionally",
        "search": "Search",
        "more": "More",
        "download": "Download",
        "created_at": "Created at",
        "created_by": "Created by",
        "end_date": "End date",
        "filter_infinitive": "Filter",
        "date": "Data",
        "date_from": "Date from",
        "date_to": "Date to",
        "years": "Years",
        "months": "Months",
        "days": "Days",
        "read_more": "Read more",
        "yes": "Yes",
        "no": "No"
    },
    "header": {
        "periodic_tasks": "Periodic tasks"
    },
    "issues": {
        "periodic_tasks_scheduler": "Periodic tasks scheduler",
        "periodic_task_nr": "task nr #{{periodic_task_id}}"
    },
    "periodic_tasks": {
        "task_list": {
            "create": "Add new periodic task",
            "empty_task_list": "No tasks found",
            "task_id": "ID",
            "client": "Client",
            "category": "Category",
            "description": "Description",
            "frequency": "Frequency",
            "start_date": "Repeat from",
            "end_date": "Repeat to"
        },
        "task_details": {
            "start_date": "Repeat from date",
            "end_date": "Repeat to date",
            "repeat": "Repeat",
            "reminder_time": "Reminder",
            "client": "Client",
            "category": "Category",
            "description": "Description",
            "additional_personal_data": "Additional personal data",
            "created_at": "Created at",
            "created_by": "Created by",
            "updated_at": "Updated at",
            "updated_by": "Updated by",
            "assets": "Zasoby",
            "locations": "Locations",
            "devices": "Devices",
            "schedule": "Schedule",
            "history": "History"
        },
        "task_form": {
            "create": "Add task",
            "periodic_task": "Periodic task",
            "start_date": "Repeat from date",
            "end_date": "Repeat to date",
            "reminder_time": "How many days before due date reminder should be set?"
        },
        "frequencies": {
            "every_x_days_1": "Every {{interval}} day",
            "every_x_days_2": "Every {{interval}} days",
            "every_x_days_5": "Every {{interval}} days",
            "every_x_weeks_1": "Every {{interval}} week",
            "every_x_weeks_2": "Every {{interval}} weeks",
            "every_x_weeks_5": "Every {{interval}} weeks",
            "every_x_months_1": "Every {{interval}} month",
            "every_x_months_2": "Every {{interval}} months",
            "every_x_months_5": "Every {{interval}} months",
            "every_x_years_1": "Every {{interval}} year",
            "every_x_years_2": "Every {{interval}} years",
            "every_x_years_5": "Every {{interval}} years"
        },
        "reminder": {
            "days_before_due_date_1": "{{reminderTime}} day before due date",
            "days_before_due_date_2": "{{reminderTime}} days before due date",
            "days_before_due_date_5": "{{reminderTime}} days before due date"
        },
        "repeater_configurator": {
            "short_months": {
                "jan": "Jan",
                "feb": "Feb",
                "mar": "Mar",
                "apr": "Apr",
                "may": "May",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Aug",
                "sep": "Sep",
                "oct": "Oct",
                "nov": "Nov",
                "dec": "Dec"
            },
            "long_months": {
                "january": "January",
                "february": "February",
                "march": "March",
                "april": "April",
                "may": "May",
                "june": "June",
                "july": "July",
                "august": "August",
                "september": "September",
                "october": "October",
                "november": "November",
                "december": "December"
            },
            "repeat": "Repeat",
            "daily": "Daily",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "yearly": "Yearly",
            "each": "Each",
            "on_the": "On the",
            "in_which_months": "In which months?",
            "in_which_days": "In which days?",
            "every_x_days": "Every how many days?",
            "every_x_weeks": "Every how many weeks?",
            "every_x_months": "Every how many months?",
            "every_x_years": "Every how many years?",
            "monday": "Monday",
            "tuesday": "Tuesday",
            "wednesday": "Wednesday",
            "thursday": "Thursday",
            "friday": "Friday",
            "saturday": "Saturday",
            "sunday": "Sunday",
            "day": "day of month",
            "weekday": "weekday",
            "weekend_day": "weekend day",
            "first": "first",
            "second": "second",
            "third": "third",
            "fourth": "fourth",
            "fifth": "fifth",
            "last": "last",
            "at": "at",
            "at_the_following_days": "at the following days",
            "at_the_following_months": "in"
        }
    }
}
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/languages/en.ts